import { countries } from "@/app/infrastructures/misc/BulkData";
export interface ParsedRecipientResult {
  name?: string;
  phone?: string;
  phoneCode?: string;
  phoneNumber?: string;
  address?: string;
}
// =========================================================================
// PURE PLAIN STRINGS (Tanpa Sintaks Regex) - Mudah Dibaca & Di-maintain
// =========================================================================
const NOISE_WORDS: string[] = [
  // 1. Order & Form Headers (ID, EN, MY)
  "maklumat penghantaran",
  "butiran penghantaran",
  "borang pesanan",
  "maklumat penerima",
  "format order",
  "data pengiriman",
  "form order",
  "order form",
  "order details",
  "order info",
  "shipping info",
  "shipping details",
  "shipping detail",
  "shipping address",
  "ship to",
  "delivery details",
  "delivery info",
  "delivery address",
  "deliver to",
  "send to",
  "bill to",
  "customer info",
  "customer details",
  "recipient info",
  "recipient details",
  "invoice",
  "waybill",
  "tracking number",
  "po number",
  // 2. Package & Item Nouns (ID, EN, MY)
  "this package",
  "the package",
  "this parcel",
  "the parcel",
  "this shipment",
  "the shipment",
  "bungkusan",
  "barangan",
  "pesanan ini",
  "barang ini",
  "ordernya",
  "orderan",
  "order",
  "pesanannya",
  "pesanan",
  "paketnya",
  "paket",
  "kirimannya",
  "kiriman",
  "barangnya",
  "barang",
  "package",
  "parcel",
  "shipment",
  "item",
  // 3. Honorifics, Titles & Roles (ID, EN, MY)
  "atas nama",
  "a/n",
  "a.n",
  "an",
  "sdr/i",
  "sdri",
  "sdr",
  "saudara/i",
  "saudari",
  "saudara",
  "tuan",
  "puan",
  "encik",
  "cik",
  "cikgu",
  "dato",
  "datin",
  "kepada yth",
  "yth",
  "bapak",
  "ibu",
  "bpk",
  "mrs",
  "mr",
  "miss",
  "ms",
  "dr",
  "nama penerima",
  "nama pembeli",
  "nama pelanggan",
  "recipient name",
  "receiver name",
  "customer name",
  "consignee name",
  "consignee",
  "recipient",
  "receiver",
  "customer",
  "buyer",
  "pembeli",
  "pelanggan",
  "attn",
  // 4. Conversational Calls, Directives & Fillers (ID, EN, MY)
  "hantar kepada",
  "hantar ke",
  "kirim kepada",
  "pos ke",
  "post ke",
  "tolong hantar",
  "minta tolong",
  "please deliver to",
  "please deliver",
  "please send to",
  "please send",
  "please ship to",
  "please ship",
  "deliver to",
  "send to",
  "ship to",
  "drop to",
  "drop off to",
  "dikirimkan ke",
  "dikirim ke",
  "kirimkan ke",
  "kirim ke",
  "drop ke",
  "antar ke",
  "tujuan",
  "alamat",
  "address",
  "destination",
  "penerima",
  "untuk",
  "data",
  "ini",
  "tolong ya",
  "kak tolong",
  "ya kak",
  "ya min",
  "tolong",
  "mohon",
  "please",
  "kindly",
  "bisa",
  "boleh",
  "dear admin",
  "hi admin",
  "hello admin",
  "dear team",
  "dear",
  "hello",
  "halo",
  "hai",
  "hi",
  "bos",
  "mas",
  "mba",
  "mbak",
  "pak",
  "bu",
  "kak",
  "gan",
  "sis",
  "min",
  "om",
  "tante",
  "abang",
  "akak",
  "bro",
  "sis",
  "ya",
  "for",
  "to",
  // 5. Phone & Contact Labels (ID, EN, MY)
  "nombor telefon",
  "nombor tel",
  "nombor hp",
  "nombor bimbit",
  "no telefon",
  "no tel",
  "no bimbit",
  "phone number",
  "mobile number",
  "contact number",
  "telephone number",
  "cell phone",
  "nomor hp",
  "nomor telp",
  "nomor tlp",
  "nomor wa",
  "nomor telepon",
  "nomor handphone",
  "nomor ponsel",
  "nomor kontak",
  "no hp",
  "no telp",
  "no tlp",
  "no wa",
  "no telepon",
  "no handphone",
  "no ponsel",
  "no kontak",
  "handphone",
  "telepon",
  "ponsel",
  "kontak",
  "contact",
  "mobile",
  "phone",
  "nomor",
  "nombor",
  "telp",
  "tlp",
  "tel",
  "hp",
  "wa",
  "no",
  // 6. Closing & Courtesies (ID, EN, MY)
  "terima kasih banyak",
  "terima kasih daun keladi",
  "terima kasih",
  "makasih",
  "thank you very much",
  "thanks very much",
  "thanks a lot",
  "thank you so much",
  "thank you",
  "thanks",
  "many thanks",
  "best regards",
  "warm regards",
  "regards",
  "cheers",
  "thx",
  "tq",
  "matur nuwun",
  "urgent",
  "segera",
  "cepat ya",
  "asap"
];
// Otomatis di-compile menjadi Regex sekali saja (urutkan terpanjang ke terpendek)
const NOISE_KEYWORDS_REGEX = new RegExp(
  `\\b(?:${[...NOISE_WORDS]
    .sort((a, b) => b.length - a.length)
    .map((w) =>
      w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/\\s+/g, "\\s*")
    )
    .join("|")})\\b`,
  "gi"
);
/**
 * Helper Pembersih Noise Percakapan (v10)
 */
function cleanConversationalNoise(str: string): string {
  if (!str) return "";
  return str
    .replace(/https?:\/\/[^\s]+/gi, "")
    .replace(
      /\[\d{1,2}[/.-]\d{1,2}[/.-]\d{2,4}[\s,]+\d{1,2}[:.]\d{2}(?::\d{2})?\][^:]*:\s*/gi,
      ""
    )
    .replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, "")
    .replace(
      /\b(?:ig|instagram|fb|facebook|tiktok|line|tg|telegram)\s*:\s*@?[a-zA-Z0-9._-]+/gi,
      ""
    )
    .replace(/@[a-zA-Z0-9._-]+/g, "")
    .replace(
      /[\u{1F300}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
      " "
    )
    .replace(/\*{1,3}|_{1,3}/g, "")
    .replace(NOISE_KEYWORDS_REGEX, "")
    .replace(/^[-*•:=,./|\s\t[\]{}()]+|[-*•:=,./|\s\t[\]{}()]+$/g, "")
    .replace(/\s+/g, " ")
    .trim();
}
function resolvePhoneCountryCode(
  rawDigits: string
): { phoneCode: string; phoneNumber: string } {
  if (!rawDigits) return { phoneCode: "+62", phoneNumber: "" };
  const digits = rawDigits.replace(/^\+/, "");
  // 1. Cek format lokal Indonesia: 08... atau 02...
  if (digits.startsWith("08")) {
    return { phoneCode: "+62", phoneNumber: digits.substring(1) };
  }
  if (digits.startsWith("02") && digits.length >= 9) {
    return { phoneCode: "+62", phoneNumber: digits.substring(1) };
  }
  // 2. Cek format lokal Malaysia: 011, 012, 013, 014, 016, 017, 018, 019
  if (/^01[0-9]{7,9}$/.test(digits)) {
    return { phoneCode: "+60", phoneNumber: digits.substring(1) };
  }
  // 3. Cocokkan dengan seluruh Country Calling Code existing Medusa (BulkData.ts)
  // Diurutkan dari calling code terpanjang (3 digit) ke terpendek (1 digit)
  const sortedCountries = [...countries].sort(
    (a, b) => b.code.length - a.code.length
  );
  for (const item of sortedCountries) {
    const plainCode = item.code.replace("+", "");
    if (digits.startsWith(plainCode)) {
      const numberOnly = digits.substring(plainCode.length).replace(/^0+/, "");
      return { phoneCode: item.code, phoneNumber: numberOnly };
    }
  }
  // Default fallback jika format tidak dikenal
  return { phoneCode: "+62", phoneNumber: digits.replace(/^0+/, "") };
}
/**
 * Sanitizer Keamanan Input (Anti-XSS & Script Injection)
 * Membersihkan script tags, iframe, object/embed, event handlers (onerror/onclick), dan skema berbahaya
 */
function sanitizeRawInput(str: string): string {
  if (!str) return "";
  return String(str)
    .replace(
      /<\s*(?:script|iframe|object|embed|style|svg|img|link|meta)\b[^>]*>.*?<\s*\/\s*(?:script|iframe|object|embed|style|svg|img|link|meta)\s*>/gis,
      ""
    )
    .replace(
      /<\s*(?:script|iframe|object|embed|style|svg|img|link|meta)\b[^>]*\/?>/gis,
      ""
    )
    .replace(/\bon\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gis, "")
    .replace(/(?:javascript|data|vbscript)\s*:/gis, "")
    .replace(/<[^>]+>/g, "");
}

const ADDRESS_KEYWORDS_REGEX = /\b(?:jl\.?|jalan|gang|gg\.?|komp(?:lek)?|blok|no\.?|rt|rw|kel(?:urahan)?|kec(?:amatan)?|kab(?:upaten)?|kota|prov(?:insi)?|dusun|desa|cluster|perum(?:ahan)?|puri|taman|residence|tower|apartemen|gedung|floor|lantai|ruang|rs|rumah\s*sakit|hospital|dekat|sebelah|depan|belakang|patokan|seberang|masjid|musholla|gereja|pos|street|st\.?|ave(?:nue)?|rd\.?|road|blvd|building|suite|unit|\d{5})\b/i;

const PARTIAL_ADDRESS_KEYWORDS_REGEX = /\b(?:metland|jl\.?|jalan|gang|gg\.?|komp(?:lek)?|blok|rt|rw|kel(?:urahan)?|kec(?:amatan)?|kab(?:upaten)?|kota|prov(?:insi)?|dusun|desa|cluster|perum(?:ahan)?|puri|taman|residence|tower|apartemen|gedung|floor|lantai|ruang|rs|rumah\s*sakit|hospital|dekat|sebelah|depan|belakang|patokan|seberang|masjid|musholla|gereja|pos|street|st\.?|ave(?:nue)?|rd\.?|road|blvd|building|suite|unit|\d{5})\b/i;

function splitAddressWithTrailingName(
  text: string
): { address: string; name?: string } {
  const trailingNameMatch = text.match(
    /^(.+?\b\d{5}\b)\s+([A-Za-z][A-Za-z\s'.]+)$/i
  );

  if (!trailingNameMatch) {
    return { address: text };
  }

  return {
    address: trailingNameMatch[1].trim(),
    name: cleanConversationalNoise(trailingNameMatch[2].trim())
  };
}

function applyPartialRecipientFallback(
  result: ParsedRecipientResult,
  activeText: string,
  phoneStr: string
): void {
  if (activeText.includes("\n")) return;

  const remaining = activeText
    .replace(phoneStr, "")
    .replace(
      /\b(?:dikirim\s*ke|kirim\s*ke|antar\s*ke|alamat(?:\s*tujuan)?|tujuan|deliver\s*to|send\s*to|ship\s*to|address)\b\s*:?/gi,
      ""
    )
    .replace(/^[-*•:=,/|\s(){}]+|[-*•:=,/|\s(){}]+$/g, "")
    .replace(/\s+/g, " ")
    .trim();

  if (!remaining) return;

  const addressMatch = remaining.match(PARTIAL_ADDRESS_KEYWORDS_REGEX);

  if (!addressMatch || addressMatch.index === undefined) {
    if (!result.name) {
      result.name = cleanConversationalNoise(remaining);
    }

    if (result.address === remaining) {
      result.address = undefined;
    }

    return;
  }

  const addressIndex = addressMatch.index;
  const nameCandidate = remaining.substring(0, addressIndex).trim();
  const addressCandidate = remaining.substring(addressIndex).trim();

  if (!addressCandidate) return;

  // ADDRESS ... POSTAL CODE + NAME
  if (addressIndex === 0) {
    const split = splitAddressWithTrailingName(addressCandidate);

    result.address = split.address;

    if (split.name) {
      result.name = split.name;
    } else if (!result.name || addressCandidate.startsWith(`${result.name} `)) {
      result.name = undefined;
    }

    return;
  }

  // NAME + ADDRESS
  if (nameCandidate) {
    result.name = cleanConversationalNoise(nameCandidate);
    result.address = addressCandidate;
  }
}

function parseTabularRecipient(text: string): ParsedRecipientResult | null {
  if (!text.includes("\t")) {
    return null;
  }

  const rows = text
    .split(/\r?\n/)
    .map((line) => line.split("\t").map((value) => value.trim()))
    .filter((columns) => columns.some(Boolean));

  if (!rows.length) {
    return null;
  }

  // Parser ini menghasilkan 1 recipient.
  // Ambil row pertama yang memiliki minimal 2 kolom berisi.
  for (const columns of rows) {
    const values = columns.filter(Boolean);

    if (values.length < 2) {
      continue;
    }

    // Cari kolom phone berdasarkan bentuk angka.
    const phoneIndex = values.findIndex((value) => {
      const digits = value.replace(/[\s.\-()+]/g, "");

      return /^\+?\d{9,15}$/.test(digits);
    });

    if (phoneIndex < 0) {
      continue;
    }

    const phoneStr = values[phoneIndex];
    const rawDigits = phoneStr.replace(/[\s.\-()]/g, "");

    const resolved = resolvePhoneCountryCode(rawDigits);

    const otherValues = values.filter((_, index) => index !== phoneIndex);

    if (otherValues.length < 1) {
      continue;
    }

    // Kolom yang memiliki address marker dianggap address.
    const addressIndex = otherValues.findIndex((value) =>
      ADDRESS_KEYWORDS_REGEX.test(value)
    );

    let address = "";
    let name = "";

    if (addressIndex >= 0) {
      address = otherValues[addressIndex]
        .replace(
          /\b(?:dikirim\s*ke|kirim\s*ke|antar\s*ke|alamat(?:\s*tujuan)?|tujuan|deliver\s*to|send\s*to|ship\s*to|address)\b\s*:?/gi,
          ""
        )
        .replace(/^[-*•:=,/|\s{}]+|[-*•:=,/|\s{}]+$/g, "")
        .trim();

      // Kolom selain address = name.
      const nameValue = otherValues.find((_, index) => index !== addressIndex);

      if (nameValue) {
        name = cleanConversationalNoise(nameValue);
      }
    } else if (otherValues.length === 1) {
      // Kalau cuma ada satu kolom selain phone dan tidak terlihat
      // seperti address, anggap sebagai name.
      name = cleanConversationalNoise(otherValues[0]);
    } else {
      // Kalau ada beberapa kolom tetapi tidak ada yang jelas address,
      // jangan mengambil risiko mengubah data menjadi salah.
      // Biarkan parser existing menangani input tersebut.
      continue;
    }

    if (!name && !address) {
      continue;
    }

    return {
      name: name || undefined,
      address: address || undefined,
      phone: rawDigits,
      phoneCode: resolved.phoneCode,
      phoneNumber: resolved.phoneNumber
    };
  }

  return null;
}

export function parseRecipientText(rawText: string): ParsedRecipientResult {
  if (!rawText || typeof rawText !== "string" || !rawText.trim()) {
    return {};
  }
  const result: ParsedRecipientResult = {};
  let workingCopy = sanitizeRawInput(rawText).trim();

  // -----------------------------------------------------------------------
  // 0A. Deteksi Paste dari Excel / TSV
  // -----------------------------------------------------------------------
  const tabularResult = parseTabularRecipient(workingCopy);

  if (tabularResult) {
    return tabularResult;
  }

  // -----------------------------------------------------------------------
  // 0. Deteksi Cepat: Format JSON String Mentah & Format Barcode POS (N:...;T:...;A:...;)
  // -----------------------------------------------------------------------
  if (
    workingCopy.startsWith("{") &&
    workingCopy.endsWith("}") &&
    !workingCopy.includes("}{")
  ) {
    const json = JSON.parse(workingCopy);
    const nameVal =
      json.name ||
      json.nama ||
      json.penerima ||
      json.consignee ||
      json.receiver ||
      json.customer ||
      json.pembeli ||
      "";
    const phoneVal =
      json.phone ||
      json.telepon ||
      json.telp ||
      json.hp ||
      json.mobile ||
      json.wa ||
      json.contact ||
      "";
    const addrVal =
      json.address ||
      json.alamat ||
      json.destination ||
      json.tujuan ||
      json.shipping_address ||
      "";
    if (nameVal || phoneVal || addrVal) {
      if (nameVal) result.name = cleanConversationalNoise(String(nameVal));
      if (phoneVal) {
        const rawDigits = String(phoneVal).replace(/[\s\-.()]/g, "");
        result.phone = rawDigits;
        result.phoneCode = "+62";
        result.phoneNumber = rawDigits.startsWith("08")
          ? rawDigits.substring(1)
          : rawDigits.replace(/^\+?62/, "");
      }
      if (addrVal)
        result.address = String(addrVal)
          .replace(/https?:\/\/[^\s]+/gi, "")
          .replace(/^[-*•:=,/|\s{}]+|[-*•:=,/|\s{}]+$/g, "")
          .trim();
      return result;
    }
  }
  // Barcode / Scanner Handheld POS: N:Bagus;T:0812...;A:Jl...;
  if (
    /\bN\s*:\s*([^;]+);\s*T\s*:\s*([^;]+);\s*A\s*:\s*([^;]+)/i.test(workingCopy)
  ) {
    const barcodeMatch = workingCopy.match(
      /\bN\s*:\s*([^;]+);\s*T\s*:\s*([^;]+);\s*A\s*:\s*([^;]+)/i
    );
    if (barcodeMatch) {
      result.name = cleanConversationalNoise(barcodeMatch[1]);
      const rawDigits = barcodeMatch[2].replace(/[\s\-.()]/g, "");
      result.phone = rawDigits;
      result.phoneCode = "+62";
      result.phoneNumber = rawDigits.startsWith("08")
        ? rawDigits.substring(1)
        : rawDigits.replace(/^\+?62/, "");
      result.address = barcodeMatch[3].trim();
      return result;
    }
  }
  // -----------------------------------------------------------------------
  // 1. Isolasi Blok Dropship / Bill To vs Ship To & Multi-Order Forwarding
  // -----------------------------------------------------------------------
  const multiOrderSplit = workingCopy.split(
    /\n\s*(?:order\s*2|pesanan\s*2|paket\s*2|penerima\s*2)\s*[:=-]/i
  );
  if (multiOrderSplit.length > 1) {
    workingCopy = multiOrderSplit[0].trim();
  }
  const receiverBlockRegex = /(?:\[\s*(?:penerima|receiver|consignee|ship\s*to|deliver\s*to|to|kepada|pembeli)\s*\]|\b(?:penerima|receiver|consignee|ship\s*to|deliver\s*to|to|kepada|pembeli)\s*:)\s*([\s\S]+)/i;
  const receiverBlockMatch = workingCopy.match(receiverBlockRegex);
  if (receiverBlockMatch && receiverBlockMatch[1]) {
    if (
      /(?:\[\s*(?:pengirim|sender|from|penjual|bill\s*to)\s*\]|\b(?:pengirim|sender|from|penjual|bill\s*to)\s*:)/i.test(
        workingCopy
      )
    ) {
      workingCopy = receiverBlockMatch[1];
    }
  }
  // Normalisasi teks, bersihkan markdown bold/bullet, quotes sel TSV Excel, garis pemisah ===/---, WA timestamps, dan URLs
  let normalized = workingCopy
    .replace(/https?:\/\/[^\s]+/gi, "")
    .replace(
      /\[\d{1,2}[/.-]\d{1,2}[/.-]\d{2,4}[\s,]+\d{1,2}[:.]\d{2}(?::\d{2})?\][^:]*:\s*/gi,
      ""
    )
    .replace(/^[=\-—_]{3,}\s*$/gm, "")
    .replace(/\*{1,3}|_{1,3}/g, "")
    .replace(/\r\n/g, "\n")
    .replace(/^"|"$/gm, "")
    .replace(/"\t"/g, "\t")
    .replace(/"\t|\t"/g, "\t")
    .replace(/\t+/g, " | ")
    .replace(
      /[\u{1F300}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
      " "
    )
    .trim();
  normalized = normalized
    .split("\n")
    .filter(
      (line) =>
        !/^\s*(?:pesanan\s*baru\s*dari\s*katalog|invoice[/\w-]*|waybill[/\w-]*|tracking(?:\s*number)?\s*:|po(?:\s*number)?\s*:|no(?:mor)?\.?\s*(?:pesanan|order|resi|invoice|waybill|trx)|order\s*id|metode(?:\s*pembayaran)?\s*:|payment\s*:|(?:\d+x|\d+\s*pcs)\b)/i.test(
          line
        )
    )
    .join("\n")
    .trim();
  // -----------------------------------------------------------------------
  // 2. Ekstraksi Nomor Telepon (Anchor Pivot Terkuat)
  // Mendukung titik: 0812.3344.5566, strip, spasi 4-digit, kode area (021), internasional (+62, +60, +65, +63)
  // Prioritaskan nomor utama jika ada multi kontak (HP Utama vs HP Cadangan)
  // -----------------------------------------------------------------------
  const primaryPhoneRegex = /(?:(?:hp|telp|tlp|wa|telepon|kontak|phone|mobile|contact|tel|nomor|no)\s*(?:utama|primary|penerima|hp|wa)?\s*[:=-]?\s*)(\+?\d[\d\s.\-()]{7,18}\d)/i;
  const primaryMatch = normalized.match(primaryPhoneRegex);
  const phoneRegex = /(?:\(\s*0\d{2,4}\s*\)[\s.-]?\d{3,4}[\s.-]?\d{3,5}|(?:\+?62|62|0)[\s.-]?(?:\(\d{2,4}\)|\d{2,4})[\s.-]?\d{3,4}[\s.-]?\d{3,5}|(?:\+?60|60|0)[\s.-]?[1-9]\d{1,2}[\s.-]?\d{3,4}[\s.-]?\d{3,4}|(?:\+?65|65)[\s.-]?[689]\d{1,4}(?:[\s.-]?\d{3,4}){1,3}|(?:\+?63|63)[\s.-]?[9]\d{2}[\s.-]?\d{3}[\s.-]?\d{4}|\b(?:\+?\d{1,3}[\s.-]?)?\d{3,5}[\s.-]?\d{3,5}[\s.-]?\d{3,5}\b|\b\d{9,15}\b)/;
  const indonesiaPhoneRegex = /(?:\+?62[\s.-]?|0)8[\d\s.-]{8,13}\d\b/;
  const malaysiaPhoneRegex = /\+?60[\s.-]?[1-9][\d\s.-]{7,12}\d\b/;

  let phoneStr = "";
  let phoneMatch: RegExpMatchArray | null = null;

  if (primaryMatch && primaryMatch[1]) {
    phoneStr = primaryMatch[1].trim();
  } else {
    const indonesiaPhoneMatch = normalized.match(indonesiaPhoneRegex);

    if (indonesiaPhoneMatch) {
      phoneMatch = indonesiaPhoneMatch;
      phoneStr = indonesiaPhoneMatch[0].trim();
    } else {
      const malaysiaPhoneMatch = normalized.match(malaysiaPhoneRegex);

      if (malaysiaPhoneMatch) {
        phoneMatch = malaysiaPhoneMatch;
        phoneStr = malaysiaPhoneMatch[0].trim();
      } else {
        phoneMatch = normalized.match(phoneRegex);

        if (phoneMatch) {
          phoneStr = phoneMatch[0].trim();
        }
      }
    }
  }

  if (phoneStr) {
    const rawDigits = phoneStr.replace(/[\s\-.()]/g, "");
    result.phone = rawDigits;
    // Breakdown phoneCode dan local phoneNumber untuk form state Genesis
    const resolved = resolvePhoneCountryCode(rawDigits);
    result.phoneCode = resolved.phoneCode;
    result.phoneNumber = resolved.phoneNumber;
  }
  // -----------------------------------------------------------------------
  // 3. Ekstraksi Pola Percakapan Chat / E-Commerce Form & SHIP TO Block
  // -----------------------------------------------------------------------
  let activeText = normalized;
  // Bersihkan greeting awal seperti "Hi Admin,", "Halo Min,"
  activeText = activeText
    .replace(
      /^\s*(?:halo|hai|hi|hello|dear|pagi|siang|sore|malam|permisi|assalamu'?alaikum)\b[^\n,]*[,:-]?\s*/i,
      ""
    )
    .trim();
  const lines = activeText.split("\n");
  const filteredLines: string[] = [];
  for (const l of lines) {
    if (
      /^\s*(?:halo|hai|hi|hello|dear|pagi|siang|sore|malam|permisi|assalamu'?alaikum)\b.*(?:admin|min|kak|gan|sis|lion\s*parcel|cs|team)\b/i.test(
        l.trim()
      )
    ) {
      continue;
    }
    filteredLines.push(l);
  }
  activeText = filteredLines.join("\n").trim();

  const conversationalNamePatterns = [
    /(?:please\s+)?(?:deliver|send|ship|kirim(?:kan)?|antar)(?:\s+(?:this|the)?\s*(?:package|parcel|shipment|barang|paket|pesanan))?\s+(?:to|ke)\s*(?:mr\.?|mrs\.?|ms\.?|mas|mbak|pak|bu)?\s*:?\s*([A-Za-z][A-Za-z\s'.]*?)(?=(?:,|\n|\||\(|\bya\b|\bkak\b|\bgan\b|\bsis\b|\bnomor\b|\bno\b|\b08|\+?62|\+?60|\+?65|\+?63|\bphone\b|\bmobile\b|\bcontact\b|\btel\b))/i,

    /(?:order(?:nya|an)?|pesanan(?:nya)?|paket(?:nya)?|kiriman(?:nya)?|package|parcel|shipment)\s+(?:atas\s*nama|a[/.]n|untuk|penerima|pembeli|recipient)\s*:?\s*([A-Za-z][A-Za-z\s'.]*?)(?=(?:,|\n|\||\(|\bya\b|\bkak\b|\bgan\b|\bsis\b|\bnomor\b|\bno\b|\b08|\+?62|\+?60|\+?65|\bphone\b|\bmobile\b|\bcontact\b|\btel\b))/i
  ];

  let convNameMatch: RegExpMatchArray | null = null;

  for (const pattern of conversationalNamePatterns) {
    const match = activeText.match(pattern);

    if (match?.[1]) {
      convNameMatch = match;
      break;
    }
  }

  if (convNameMatch?.[1]) {
    result.name = cleanConversationalNoise(convNameMatch[1]);
    activeText = activeText.replace(convNameMatch[0], "");
  }
  // -----------------------------------------------------------------------
  // 4. Ekstraksi Berbasis Label Eksplisit (Mendukung [], {}, |, :)
  // -----------------------------------------------------------------------
  if (!result.name) {
    const nameLabelRegex = /(?:[{[]\s*(?:nama(?:\s*(?:penerima|lengkap|pelanggan|customer|pembeli))?|penerima|pembeli|kepada|yth|attn|recipient(?:\s*name)?|receiver(?:\s*name)?|customer(?:\s*name)?|consignee|name|nm|pnr|ship\s*to|deliver\s*to)\s*[:=-]?\s*[}\]]\s*([^\n,|[\]{}]+)|[{[]\s*(?:nama(?:\s*(?:penerima|lengkap|pelanggan|customer|pembeli))?|penerima|pembeli|kepada|yth|attn|recipient(?:\s*name)?|receiver(?:\s*name)?|customer(?:\s*name)?|consignee|name|nm|pnr|ship\s*to|deliver\s*to)\s*[:=-]\s*([^\n,|[\]{}]+)[}\]]|^\s*(?:nama(?:\s*(?:penerima|lengkap|pelanggan|customer|pembeli))?|penerima|pembeli|kepada|yth|attn|recipient(?:\s*name)?|receiver(?:\s*name)?|customer(?:\s*name)?|consignee|name|nm|pnr|ship\s*to|deliver\s*to)\s*[:=-]\s*([^\n,|[\]{}]+)|\b(?:nama|name|penerima|customer|attn)\s*:\s*([^\n,|[\]{}]+))/im;
    const nameMatch = activeText.match(nameLabelRegex);
    if (nameMatch) {
      let candidateName = (
        nameMatch[1] ||
        nameMatch[2] ||
        nameMatch[3] ||
        nameMatch[4] ||
        ""
      ).trim();
      const phoneInNameMatch = candidateName.match(
        /\((?:\+?\d[\d\s.\-()]{5,16}\d)\)/
      );
      if (phoneInNameMatch) {
        if (!result.phone) {
          const rawInNameDigits = phoneInNameMatch[0].replace(/[\s\-.()]/g, "");
          result.phone = rawInNameDigits;
          const resolved = resolvePhoneCountryCode(rawInNameDigits);
          result.phoneCode = resolved.phoneCode;
          result.phoneNumber = resolved.phoneNumber;
        }
        candidateName = candidateName.replace(phoneInNameMatch[0], "").trim();
      }
      result.name = cleanConversationalNoise(candidateName);
      activeText = activeText.replace(nameMatch[0], "");
    }
  }
  const addressLabelRegex = /(?:[{[]\s*(?:alamat(?:\s*(?:penerima|tujuan|lengkap|kirim|pengiriman))?|tujuan|destination(?:\s*address)?|shipping\s*(?:address|info|details)?|delivery\s*address|address|ship\s*to|almt|addr|dest)\s*[:=-]?\s*[}\]]\s*([\s\S]+)|[{[]\s*(?:alamat(?:\s*(?:penerima|tujuan|lengkap|kirim|pengiriman))?|tujuan|destination(?:\s*address)?|shipping\s*(?:address|info|details)?|delivery\s*address|address|ship\s*to|almt|addr|dest)\s*[:=-]\s*([^\n[\]{}]+)[}\]]|^\s*(?:alamat(?:\s*(?:penerima|tujuan|lengkap|kirim|pengiriman))?|tujuan|destination(?:\s*address)?|shipping\s*(?:address|info|details)?|delivery\s*address|address|ship\s*to|almt|addr|dest)\s*[:=-]\s*([\s\S]+)|\b(?:alamat|almt|addr|address|dest|shipping\s*info)\s*:\s*([\s\S]+))/im;
  const addressMatch = activeText.match(addressLabelRegex);
  if (addressMatch) {
    const rawExtracted =
      addressMatch[1] ||
      addressMatch[2] ||
      addressMatch[3] ||
      addressMatch[4] ||
      "";
    const cleanAddr = rawExtracted
      .split(
        /\n\s*(?:\b(?:nama|penerima|kepada|recipient|receiver|name|customer|pembeli|pelanggan|no\.?\s*(?:hp|tlp|wa|telepon|telp|bimbit)|phone|mobile|tel|contact|item|barang|barangan|pesanan|total|ongkir|kurir|courier|ekspedisi|layanan|service|metode(?:\s*pembayaran)?|payment|tracking(?:\s*number)?|po(?:\s*number)?)\b\s*[:=-]|[{[]\s*(?:nama|no|telp|hp)\s*)/i
      )[0]
      .split(/}\s*(?:{|\b)/)[0]
      .trim();
    result.address = cleanAddr
      .replace(/^[-*•:=,/|\s{}]+|[-*•:=,/|\s{}]+$/g, "")
      .trim();
  }
  // -----------------------------------------------------------------------
  // 5. Fallback Heuristic (Single-line, Address-First, Phone-First, Multi-line)
  // -----------------------------------------------------------------------
  const addressKeywords = /\b(?:jl\.?|jalan|gang|gg\.?|komp(?:lek)?|blok|no\.?|rt|rw|kel(?:urahan)?|kec(?:amatan)?|kab(?:upaten)?|kota|prov(?:insi)?|dusun|desa|cluster|perum(?:ahan)?|puri|taman|residence|tower|apartemen|gedung|floor|lantai|ruang|rs|rumah\s*sakit|hospital|dekat|sebelah|depan|belakang|patokan|seberang|masjid|musholla|gereja|pos|street|st\.?|ave(?:nue)?|rd\.?|road|blvd|building|suite|unit|\d{5})\b/i;
  if (!result.address) {
    if (!activeText.includes("\n")) {
      if (result.name && activeText.trim()) {
        const remain = activeText
          .replace(phoneStr, "")
          .replace(
            /\b(?:dikirim\s*ke|kirim\s*ke|antar\s*ke|alamat(?:\s*tujuan)?|tujuan|deliver\s*to|send\s*to|ship\s*to|address)\b\s*:?/gi,
            ""
          )
          .replace(/^[-*•:=,/|\s(){}]+|[-*•:=,/|\s(){}]+$/g, "")
          .trim();
        if (remain) result.address = remain;
      } else if (phoneMatch) {
        const phoneIdx = activeText.indexOf(phoneStr);
        const before = activeText.substring(0, phoneIdx).trim();
        const after = activeText.substring(phoneIdx + phoneStr.length).trim();

        // ================================================================
        // CASE 1: PHONE DI TENGAH
        // NAME | PHONE | ADDRESS
        //
        // Example:
        // Ramadhani Adiwangsa 605156018202 Metland Cibitung Cluster Lisse
        //
        // before = "Ramadhani Adiwangsa"
        // after  = "Metland Cibitung Cluster Lisse"
        // ================================================================
        if (before && after) {
          // ================================================================
          // CASE 1A: PHONE DI TENGAH, ADDRESS SEBELUM PHONE
          //
          // Example:
          // Metland Cibitung Cluster Lisse Blok AM1/1 No.123456,
          // CIkarang Barat Prov. Jawa Barat, Indonesia 17530
          // 6285156018202
          // Ramadhani Adiwangsa
          //
          // before = ADDRESS
          // after  = NAME
          //
          // Jangan treat before sebagai name hanya karena phone berada
          // di tengah. Cek dulu apakah before sudah memiliki address marker.
          // ================================================================
          if (addressKeywords.test(before) && !addressKeywords.test(after)) {
            if (!result.address) {
              result.address = before
                .replace(
                  /\b(?:dikirim\s*ke|kirim\s*ke|antar\s*ke|alamat(?:\s*tujuan)?|tujuan|deliver\s*to|send\s*to|ship\s*to|address)\b\s*:?/gi,
                  ""
                )
                .replace(/^[-*•:=,/|\s{}]+|[-*•:=,/|\s{}]+$/g, "")
                .trim();
            }

            if (!result.name) {
              result.name = cleanConversationalNoise(after);
            }
          } else {
            // ==============================================================
            // CASE 1B: PHONE DI TENGAH
            // NAME | PHONE | ADDRESS
            //
            // Example:
            // Ramadhani Adiwangsa 605156018202 Metland Cibitung Cluster Lisse
            //
            // before = NAME
            // after  = ADDRESS
            // ==============================================================
            if (!result.name) {
              result.name = cleanConversationalNoise(before);
            }

            if (!result.address) {
              result.address = after
                .replace(
                  /\b(?:dikirim\s*ke|kirim\s*ke|antar\s*ke|alamat(?:\s*tujuan)?|tujuan|deliver\s*to|send\s*to|ship\s*to|address)\b\s*:?/gi,
                  ""
                )
                .replace(/^[-*•:=,/|\s{}]+|[-*•:=,/|\s{}]+$/g, "")
                .trim();
            }
          }

          // ================================================================
          // CASE 2: PHONE DI BELAKANG
          //
          // NAME + ADDRESS | PHONE
          //
          // Example:
          // Ramadhani Adiwangsa Metland Cibitung Cluster Lisse 605156018202
          //
          // before = "Ramadhani Adiwangsa Metland Cibitung Cluster Lisse"
          // after  = ""
          //
          // Di sini baru kita split before menjadi NAME + ADDRESS.
          // ================================================================
        } else if (before && !after) {
          const addressStartMatch = before.match(
            /\b(?:metland|jl\.?|jalan|gang|gg\.?|komp(?:lek)?|blok|rt|rw|kel(?:urahan)?|kec(?:amatan)?|kab(?:upaten)?|kota|prov(?:insi)?|dusun|desa|cluster|perum(?:ahan)?|puri|taman|residence|tower|apartemen|gedung|floor|lantai|ruang|rs|rumah\s*sakit|hospital|dekat|sebelah|depan|belakang|patokan|seberang|masjid|musholla|gereja|pos|street|st\.?|ave(?:nue)?|rd\.?|road|blvd|building|suite|unit)\b/i
          );

          if (addressStartMatch?.index !== undefined) {
            const nameCandidate = before
              .substring(0, addressStartMatch.index)
              .trim();

            const addressCandidate = before
              .substring(addressStartMatch.index)
              .trim();

            if (
              nameCandidate &&
              addressCandidate &&
              nameCandidate.length <= 50
            ) {
              result.name = cleanConversationalNoise(nameCandidate);
              result.address = addressCandidate;
            }
          }

          // ================================================================
          // FALLBACK EXISTING
          // Kalau split NAME + ADDRESS di atas gagal,
          // tetap jalankan heuristic lama.
          // ================================================================
          if (!result.address) {
            const postalCodeMatch = before.match(/\b\d{5}\b/);

            if (postalCodeMatch) {
              const postalCodeIndex = postalCodeMatch.index ?? -1;

              if (postalCodeIndex >= 0) {
                const addressStartMatch = before.match(
                  /\b(?:jl\.?|jalan|gang|gg\.?|komp(?:lek)?|blok|rt|rw|kel(?:urahan)?|kec(?:amatan)?|kab(?:upaten)?|kota|prov(?:insi)?|dusun|desa|cluster|perum(?:ahan)?|puri|taman|residence|tower|apartemen|gedung|floor|lantai|ruang|rs|rumah\s*sakit|hospital|dekat|sebelah|depan|belakang|patokan|seberang|masjid|musholla|gereja|pos|street|st\.?|ave(?:nue)?|rd\.?|road|blvd|building|suite|unit)\b/i
                );

                if (addressStartMatch?.index !== undefined) {
                  const nameCandidate = before
                    .substring(0, addressStartMatch.index)
                    .trim();

                  const addressCandidate = before
                    .substring(addressStartMatch.index)
                    .trim();

                  if (
                    nameCandidate &&
                    addressCandidate &&
                    nameCandidate.length <= 50
                  ) {
                    const trailingNameMatch = addressCandidate.match(
                      /^(.+?\b\d{5}\b)\s+([A-Za-z][A-Za-z\s'.]+)$/i
                    );

                    if (trailingNameMatch) {
                      result.name = cleanConversationalNoise(
                        trailingNameMatch[2].trim()
                      );

                      result.address = `${nameCandidate} ${trailingNameMatch[1].trim()}`;
                    } else {
                      result.name = cleanConversationalNoise(nameCandidate);
                      result.address = addressCandidate;
                    }
                  }
                }
              }
            }
          }

          if (!result.address) {
            const nameInAddrRegex = /\b(?:atas\s*nama|a[/.]n|an|penerima|nama)\s*:?\s*([A-Za-z\s'.]+)$/i;

            const nameInAddrMatch = before.match(nameInAddrRegex);

            if (nameInAddrMatch) {
              result.name = cleanConversationalNoise(nameInAddrMatch[1]);

              result.address = before
                .replace(nameInAddrRegex, "")
                .replace(/^[-*•:=,/|\s{}]+|[-*•:=,/|\s{}]+$/g, "")
                .trim();
            } else {
              const trailingNameMatch = before.match(
                /^(.+?\b\d{5}\b)\s+([A-Za-z][A-Za-z\s'.]+)$/i
              );

              if (trailingNameMatch) {
                const addressCandidate = trailingNameMatch[1].trim();
                const nameCandidate = trailingNameMatch[2].trim();

                if (
                  addressCandidate &&
                  nameCandidate &&
                  !addressKeywords.test(nameCandidate)
                ) {
                  result.address = addressCandidate;
                  result.name = cleanConversationalNoise(nameCandidate);
                }
              }
            }
          }

          // Last fallback:
          // kalau semua heuristic gagal, jangan kehilangan before.
          if (!result.address) {
            result.address = before
              .replace(/^[-*•:=,/|\s{}]+|[-*•:=,/|\s{}]+$/g, "")
              .trim();

            if (after && !result.name) {
              result.name = cleanConversationalNoise(after);
            }
          }

          // ================================================================
          // CASE 3: PHONE DI DEPAN
          // PHONE | NAME + ADDRESS
          //
          // Existing logic lo dipertahankan.
          // ================================================================
        } else if (!before && after) {
          const addressStartRegex = /\b(?:metland|jl\.?|jalan|gang|gg\.?|komp(?:lek)?|blok|rt|rw|kel(?:urahan)?|kec(?:amatan)?|kab(?:upaten)?|kota|prov(?:insi)?|dusun|desa|cluster|perum(?:ahan)?|puri|taman|residence|tower|apartemen|gedung|floor|lantai|ruang|rs|rumah\s*sakit|hospital|dekat|sebelah|depan|belakang|patokan|seberang|masjid|musholla|gereja|pos|street|st\.?|ave(?:nue)?|rd\.?|road|blvd|building|suite|unit)\b/i;

          const addressStartMatch = after.match(addressStartRegex);

          if (addressStartMatch?.index !== undefined) {
            const nameCandidate = after
              .substring(0, addressStartMatch.index)
              .trim();

            const addressCandidate = after
              .substring(addressStartMatch.index)
              .trim();

            if (
              nameCandidate &&
              addressCandidate &&
              nameCandidate.length <= 50
            ) {
              result.name = cleanConversationalNoise(nameCandidate);
              result.address = addressCandidate;
            } else if (addressStartMatch.index === 0) {
              const split = splitAddressWithTrailingName(addressCandidate);

              result.address = split.address;

              if (split.name) {
                result.name = split.name;
              }
            }
          }

          if (!result.name && !result.address) {
            const parts = after
              .split(/[-|,]\s*/)
              .map((p) => p.trim())
              .filter((p) => p.length > 0);

            if (parts.length >= 2) {
              const firstPart = parts[0];

              if (addressKeywords.test(firstPart)) {
                const addressParts = [...parts];

                const lastPart = addressParts[addressParts.length - 1];

                const trailingNameMatch = lastPart.match(
                  /^(.+?\b\d{5}\b)\s+([A-Za-z][A-Za-z\s'.]+)$/i
                );

                if (trailingNameMatch) {
                  addressParts[
                    addressParts.length - 1
                  ] = trailingNameMatch[1].trim();

                  if (!result.name) {
                    result.name = cleanConversationalNoise(
                      trailingNameMatch[2].trim()
                    );
                  }
                }

                if (!result.address) {
                  result.address = addressParts
                    .join(", ")
                    .replace(/^[-*•:=,/|\s{}]+|[-*•:=,/|\s{}]+$/g, "")
                    .trim();
                }
              } else {
                if (!result.name) {
                  result.name = cleanConversationalNoise(firstPart);
                }

                if (!result.address) {
                  result.address = parts
                    .slice(1)
                    .join(", ")
                    .trim();
                }
              }
            } else if (parts.length === 1) {
              if (addressKeywords.test(parts[0])) {
                if (!result.address) result.address = parts[0];
              } else {
                if (!result.name) {
                  result.name = cleanConversationalNoise(parts[0]);
                }
              }
            }
          }
        }
      }
    } else {
      const rawLines = activeText
        .split("\n")
        .map((l) => l.trim())
        .filter((l) => l.length > 0);
      const addressLines: string[] = [];
      for (const line of rawLines) {
        if (
          /^\s*(?:\*?\s*format\s*order\*?|pesanan\s*baru|invoice[/\w-]*|waybill[/\w-]*|catatan\s*:|note\s*:|item\s*:|barang\s*:|total\s*:|kurir\s*:|courier\s*:|layanan\s*:|ongkir\s*:|metode(?:\s*pembayaran)?\s*:|payment\s*:|no(?:mor)?\.?\s*hp\s*(?:cadangan|alternatif|2)\s*:)/i.test(
            line
          )
        ) {
          continue;
        }
        // Filter baris preamble murni seperti "Kak tolong kirim ke:\n", "Kirim ke Mas Bagus ya"
        if (
          /^\s*(?:kak|gan|sis|min|om|tante|tolong|mohon|bisa|bos|please)?\s*(?:dikirim(?:kan)?\s*ke|kirim(?:kan)?\s*ke|antar\s*ke|deliver\s*to|send\s*to|tujuan|alamat)\s*:?\s*$/i.test(
            line
          )
        )
          continue;
        if (
          /^\s*(?:halo|hai|hi|hello|pagi|siang|sore|malam|makasih|terima\s*kasih|thanks(?:\s*a\s*lot)?|thank\s*you)\b/i.test(
            line
          )
        )
          continue;
        let lineClean = phoneStr ? line.replace(phoneStr, "").trim() : line;
        lineClean = lineClean
          .replace(
            /\b(?:dikirim(?:kan)?\s*ke|kirim(?:kan)?\s*ke|antar\s*ke|alamat(?:\s*tujuan)?|tujuan|deliver\s*to|send\s*to)\b\s*:?/gi,
            ""
          )
          .replace(
            /\b(?:nama(?:\s*(?:penerima|lengkap|pelanggan|customer|pembeli))?|penerima|pembeli|kepada|yth|attn|recipient(?:\s*name)?|receiver(?:\s*name)?|customer(?:\s*name)?|consignee|name|nm|pnr)\b\s*[:=-]?/gi,
            ""
          )
          .replace(
            /\b(?:no(?:mor)?\.?\s*(?:hp|tlp|wa|telepon|telp)|phone|mobile|tel|contact|wa)\b\s*[:=-]?/gi,
            ""
          )
          .replace(
            /\b(?:\+?62|0)[\s.-]?8[1-9]\d{1,2}[\s.-]?\d{3,4}[\s.-]?\d{3,5}\b/g,
            ""
          )
          .replace(/^[-*•:,.\s[\]{}()]+|[-*•:,.\s[\]{}()]+$/g, "")
          .trim();
        if (!lineClean) continue;
        if (
          /^(?:kak|gan|sis|min|mas|mba|mbak|pak|bu|om|tante|tolong|mohon|bisa|ya|kak\s*tolong|tolong\s*ya|ya\s*min|ya\s*kak|makasih|thanks)$/i.test(
            lineClean
          )
        )
          continue;
        if (result.name) {
          let withoutNameAndPhone = lineClean;
          withoutNameAndPhone = withoutNameAndPhone.replace(
            new RegExp(
              result.name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
              "gi"
            ),
            ""
          );
          withoutNameAndPhone = withoutNameAndPhone
            .replace(
              /\b(?:order(?:nya|an)?|pesanan(?:nya)?|paket(?:nya)?|kiriman(?:nya)?|package|parcel|shipment|atas\s*nama|a[/.]n|untuk|penerima|pembeli|recipient)\b/gi,
              ""
            )
            .replace(
              /\b(?:nomor(?:nya)?|no|telp|hp|wa|phone|mobile|contact|tel)\b/gi,
              ""
            )
            .replace(
              /\b(?:ya|kak|gan|sis|min|om|tante|tolong|mohon|please|terima\s*kasih|makasih|thanks)\b/gi,
              ""
            )
            .replace(/^[-*•:,.\s[\]{}()]+|[-*•:,.\s[\]{}()]+$/g, "")
            .trim();
          if (!withoutNameAndPhone) continue;
        }
        if (addressKeywords.test(lineClean)) {
          const addressPrefixRegex = /^(?:dikirim(?:kan)?\s*ke|kirim(?:kan)?\s*ke|antar\s*ke|alamat(?:\s*tujuan)?|tujuan)\b\s*:?\s*/i;

          let trimmedAddr = lineClean
            .replace(addressPrefixRegex, "")
            .replace(/^[-*•:=,/|\s{}]+/, "")
            .trim();
          trimmedAddr = trimmedAddr
            .replace(
              /\b(?:dikirim\s*ke|kirim\s*ke|antar\s*ke|alamat(?:\s*tujuan)?)\b\s*:?/gi,
              ""
            )
            .replace(/^[-*•:=,/|\s{}]+/, "")
            .trim();
          if (trimmedAddr) {
            addressLines.push(trimmedAddr);
          }
        } else if (result.name) {
          addressLines.push(lineClean);
        } else {
          if (!result.name) {
            const candidateName = cleanConversationalNoise(lineClean);
            if (candidateName && candidateName.length <= 50) {
              result.name = candidateName;
            }
          }
        }
      }
      if (addressLines.length > 0) {
        result.address = addressLines
          .join(", ")
          .replace(/^[-*•:=,/|\s{}]+/, "")
          .replace(/(?:,\s*){2,}/g, ", ")
          .trim();
      }
    }
  }
  // -----------------------------------------------------------------------
  // 6. Sanitasi Akhir
  // -----------------------------------------------------------------------
  const trailingDelimiters = /^[-*•:=,/|\s{}]+|[-*•:=,/|\s{}]+$/g;

  if (result.name) {
    result.name = cleanConversationalNoise(result.name);
  }

  if (result.address) {
    const closingTrigger = result.address.search(
      /(?:[.,\s]|^)\s*(?:terima\s*kasih|makasih|thanks(?:\s*a\s*lot)?|thank\s*you|thx|tq|matur\s*nuwun|urgent|segera|ini\s*sampai|kena\s*ongkir|berapa\s*hari|bisa\s*cod|tolong\s*di-?packing|packing\s*kayu|asuransikan|asuransi|please)\b/i
    );

    if (closingTrigger >= 0) {
      result.address = result.address.substring(0, closingTrigger).trim();
    }

    result.address = result.address
      .replace(/https?:\/\/[^\s]+/gi, "")
      .replace(trailingDelimiters, "")
      .trim();
  }

  // -----------------------------------------------------------------------
  // 7. Partial recipient fallback
  // -----------------------------------------------------------------------
  applyPartialRecipientFallback(result, activeText, phoneStr);

  return result;
}
